module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-shijiazhuang.d66dfddb.png";